import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { CookieConsentProvider } from './contexts/CookieConsentContext';
import './index.css';

// Debug: Check if environment variables are loading
console.log('Environment check:', {
  stripeKeyAvailable: !!import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY,
  stripeKeyLength: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY ? import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY.length : 0,
  stripeKeyPrefix: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY ? import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY.substring(0, 8) + '...' : 'undefined',
  nodeEnv: import.meta.env.MODE,
  dev: import.meta.env.DEV,
  prod: import.meta.env.PROD
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <CookieConsentProvider>
      <App />
    </CookieConsentProvider>
  </React.StrictMode>,
);
